var AOS = require("./components/aos");

var currentUrl = window.location.origin + window.location.pathname;
if (!currentUrl.endsWith('/') && excludeTrailFlash(currentUrl) && !window.location.href.includes('#')) {
    currentUrl = currentUrl + '/' + window.location.search;
    window.history.pushState({path:currentUrl}, '', currentUrl);
}

function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

function excludeTrailFlash(currentUrl) {
    var flag = true;
    //List url can not add slash
    var arrExcludeUrl = [".html", "/cart", "/logout", "/mypage"];
    for(var i = 0; i < arrExcludeUrl.length; i++) {
        if(currentUrl.includes(arrExcludeUrl[i])) {
            flag = false;
            break;
        }
    }
    return flag;
}

$(function () {
    if (!$('.s_01').hasClass('s_01_fs')) {
        $('.s_01 .accordion_one .accordion_header').click(function () {
            $(this).find(".i_box").toggleClass("line_toggle");
            $(this).next('.accordion_inner').slideToggle();
            $(this).toggleClass("open");
            var elm = $(".accordion_header.open");
            var open_list = [];
            elm.map((i, e) => {
                var index = $(".accordion_header").index(e);
                open_list.push(index);
            })
            window.localStorage.setItem('accordion_one', open_list);
        });
    }
    //Set min-height
    if ($('section.footer_block').length > 0) {
        $('#maincontent').css('min-height', $(window).height() - $('#maincontent').offset().top - $('section.footer_block').outerHeight(true) + 'px');
    }
    $(window).bind("pageshow", function(event) {
            if(window.performance.getEntriesByType("navigation")[0].type === 'back_forward'){
                var elm = $(".accordion_header");
                var open_list = window.localStorage.getItem('accordion_one') || [];
                elm.map((i, e) => {
                    if(open_list.includes(i)){
                        $(e).next('.accordion_inner').slideToggle();
                        $(e).addClass("open");
                        $(e).find(".i_box").addClass("line_toggle");
                        if($(e).find(".i_box").hasClass("line_toggle")) {
                            $(e).find('img').hide();
                        }
                    }
                })
            }
            
    });

    $(window).scroll(function () {
        $('.app-recommend:visible') && $(window).width() < 769 ? $('.app-recommend').css('z-index', '1000') : '';
    });

});

$(".header__icon_wishlist").click(function () { 
    var wishlisturl = $(this).attr("data-wishlisturl");
    localStorage.setItem('currenturl', window.location.href);
    window.location.href = wishlisturl;
})

$(document).ready(function () {
    $(function () {
        $('.header-banner-mkt').slick({
            autoplay: true,
            slidesToShow: 1,
            vertical: true,
            arrows: false,
            autoplaySpeed: 2500
        });
    });

})


$('.app-recommend').on("click",()=>{
    if ($('.app-recommend').css('display') === 'none') {
        $('.header_nav').css({
            "margin-top":"0px"
        });
        $('#g-nav').css({
            "top":"0px"
        });
    }
})

// $(function () {
//     function checkIsOptionSelected (select) {
//         select.children('option').each(function () {
//             if ($(this).prop('selected') && !$(this).val()) {
//                 return false;
//             }
//         })
//         return true;
//     }

//     function getOptionSelected (select) {
//         return select.find(":selected").val();
//     }

//     $('select[name=year], select[name=yearOfBirth], select.year-select').on('focusin', function () {
//         var selected = getOptionSelected($(this));
//         if (checkIsOptionSelected($(this)) && !selected) {
//             $(this).children('option[value=2004]').prop('selected', true);
//         }
//     });
// });



$(function () {
    var menuSection = $('#g-nav, .back');
    function hamburgerMenuAppearSP () {
        var height = $('.header_block').outerHeight() + $('.header_block').offset().top;
        var topPosition = $(window).scrollTop();
        menuSection.css('top', '0' + 'px');
    }

    $('body').on('click', '.app-close', function () {
        handleScroll();
    });

    $(document).ready(function () {
        localStorage.removeItem('offset-top');
        if ($(window).width() < 768) {
            hamburgerMenuAppearSP();
        } else {
            $('#g-nav, .back').css('top', '0px');
        }
    });
    $(window).resize(function () {
        if ($(window).width() < 768) {
            hamburgerMenuAppearSP();
        } else {
            $('#g-nav, .back').css('top', '0px');
            localStorage.removeItem('offset-top');
        }
    });

    $(window).on('scroll', function () {
        handleScroll();
    });

    $(window).on('load', function () {
        handleScroll();
    });
})

$(function () {
    $('.header__hamburger').on('click', function () {
        var widthScrollBar = window.innerWidth - document.documentElement.clientWidth;
        var width = $(window).width();
        var appRecommend = $('.app-recommend:visible').outerHeight() || 0;
        var sliderBanner = $('.header-banner-mkt').length > 0 ? 32 : 0;
        var heighNav = $('.header_block').outerHeight();
        var heightBlock1 = 0;
        var topCloseBtn = 0;
        if (!$('#g-nav.overlay').length) {
            $('#g-nav').scrollTop(0).find('.block2_2 .area').scrollTop(0);
        } else {
            $('body').css('touch-action', '');
            $('html').css('overflow', 'initial').css('margin-right', '0');
            localStorage.removeItem('offset-top');
        }
        $('body').toggleClass('lock_scroll');
        $('.section__search-sp').fadeOut();
        $('header').toggleClass('is-open');
        $('#g-nav').toggleClass('overlay');
        $('.back').toggleClass('black');
        $('body').css('position', '');
        $('.child_block_title').trigger('click');
        $('.search-box-pc').fadeOut();
        $('.search-field').val('');
        $('.suggestions-wrapper').css('display', 'none');
        $('.app-recommend').css('z-index', '1');
        handleScroll();
    });

    $(document).on('click', '.closebutton,.back', function () {
        var $parent = $(this).parent('#g-nav');
        $parent.find('.search-field').val('');
        $parent.find('.suggestions-wrapper').css('display', 'none');
        $('header').removeClass('is-open');
        $('#g-nav').removeClass('overlay');
        $('.back').removeClass('black');
        $('body').removeClass('lock_scroll');
        $('body').css('touch-action', '');
        $('html').css('overflow', 'initial').css('margin-right', '0');
    });
    $('.parent_block .parent_li').on('click', function() {
        if ($(this).next().hasClass('child_block show')) {
            $('.child_block').removeClass('show');
        } else if ($(this).next().hasClass('child_block')) {
            $(this).next().addClass('show');
            $('.child_block.show .c_lv_2').scrollTop(0);
            $('.block2_1').addClass('sp-dnone');
            $('.block2_2').addClass('posi_fixed');
            $('.block2_1').addClass('posi_unset');//20220616_池田 追記
            $('.tab').addClass('block2_tab_djustment');//20220616_池田 追記
            $('body').addClass('lock_scroll');
        } else {
            $('.child_block').removeClass('show');
        }
    });

    $("#g-nav").on('scroll', function(){
        if (($(window).width() < 768) && !$('.block2_2').hasClass('posi_fixed')) {
            localStorage.setItem('offset-top', $(this).scrollTop());
        }
    });

    $('.child_block_title').on('click', function() {
        $('.tabName__30 a').removeClass('noSelect');
        if ($(this).parent().hasClass('show')) {
            $('.child_block').removeClass('show');
            $('.block2_1').removeClass('sp-dnone');
            $('.block2_2').removeClass('posi_fixed');
            $('.tab').removeClass('block2_tab_djustment');//20220616_池田 追記
            $('.block2_1').removeClass('posi_unset');//20220616_池田 追記
            $('.block2_1').css('position','');//20220616_池田 追記
        }
        if ($(window).width() < 768) {
            var offsetTop = localStorage.getItem('offset-top');
            $("#g-nav").scrollTop(offsetTop);
        }
      });
});

$(function () {
    // $(document).on('mouseup', function (e) {
    //     var $container = $('.header__recommend');
    //     var $searchInput = $('.header__search');
    //     if ($searchInput.is(e.target) || $container.has(e.target).length > 0) {
    //         $('.header__recommend').addClass('appear');
    //     } else {
    //         $('.header__recommend').removeClass('appear');
    //     }
    // });

    function lockWhenFocusin () {
        if ($(window).width() < 768) {
            var offset = document.body.scrollTop;
            document.body.style.top = (offset * -1) + 'px';
            document.body.classList.add('lock_scroll');
            $('body').css('position', 'fixed');
        }
    }
    function unlockWhenFocusOut () {
        if ($(window).width() < 768) {
            var offset = parseInt(document.body.style.top, 10);
            document.body.classList.remove('lock_scroll');
            document.body.scrollTop = (offset * -1);
        }
    }

    $('.header__search').on('keyup', function (e) {
        var $parent = $(this).parent();
        if (e.target.value) {
            $parent.find('.header__search--close').removeClass('hidden');
            $parent.find('.hamburger__search--close').removeClass('hidden');
            $parent.find('.hamburger__search--btn').addClass('hidden');
        } else {
            $parent.find('.header__search--close').addClass('hidden');
            $parent.find('.hamburger__search--close').addClass('hidden');
            $parent.find('.hamburger__search--btn').removeClass('hidden');
        }
        if ($(window).width() > 768) {
            let leftOffset = $('.header__search.search-field').offset().left;
            $('.header__recommend').width($(window).width() - leftOffset - 10);
        }
    });

    $('.hamburger__search').on('keyup', function (e) {
        var $searchCloseHamburger = $('.hamburger__search--close');
        var $searchHamburger = $('.hamburger__search--btn');
        if (e.target.value) {
            $searchCloseHamburger.removeClass('hidden');
            $searchHamburger.addClass('hidden');
        } else {
            $searchCloseHamburger.addClass('hidden');
            $searchHamburger.removeClass('hidden');
        }
        if ($(window).width() >= 768 && $(window).width() < 962) {
            $('.header__recommend').width('130%');
        }
        if ($(window).width() >= 963) {
            $('.header__recommend').width('120%');
        }
    });

    $('.hamburger__search').on('focusin', lockWhenFocusin);

    $('.header__search--sp').on('keyup', function (e) {
        var $searchClose = $('.header__searchClose--sp');
        var $searchBtn = $('.header__search--btn');
        if (e.target.value) {
            $searchClose.removeClass('hidden');
            $searchBtn.addClass('hidden');
        } else {
            $searchClose.addClass('hidden');
            $searchBtn.removeClass('hidden');
        }
    });

    $('.header__searchClose--sp').on('click', function () {
        var $searchField = $('.header__search--sp');
        var $searchClose = $(this);
        var $searchBtn = $('.header__search--btn');
        $searchField.val('');
        $searchClose.addClass('hidden');
        $searchBtn.removeClass('hidden');
        $('.suggestions-wrapper').empty().css('padding-bottom', '0');
        $('.block2').css('overflow-y', 'scroll');
        $('body').removeClass('lock_scroll');
    });

    $('.header__search--close').on('click', function () {
        $('.header__search').val('');
        $(this).addClass('hidden');
        $('.suggestions-wrapper').empty();
    });

    $('.hamburger__search--close').on('click', function () {
        $('.hamburger__search').val('');
        $(this).addClass('hidden');
        $('.hamburger__search--btn').removeClass('hidden');
        $('.search-hamburger .suggestions-wrapper').empty().css('padding-bottom', '0');
        $('.block2').css('overflow-y', 'scroll');
    });

    $('.search-btn-pc').on('click', function () {
        $('.search-box-pc').fadeToggle();
    });

    $('.search-btn-sp').on('click', function () {
        $('.section__search-sp').fadeToggle();
        $('header').removeClass('is-open');
        $('#g-nav').removeClass('overlay');
        $('.back').removeClass('black');
        $('body').removeClass('lock_scroll');
        $('body').css('position', '');
        $('.block2').animate({
            scrollTop: 0
        });
        $('.child_block_title').trigger('click');
    });
});

function GethashID(hashIDName) {
    if (hashIDName) {
        //タブ設定
        $('.tab li').find('a').each(function () { //タブ内のaタグ全てを取得
            var idName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得 
            if (idName == hashIDName) { //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
                var parentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
                $('.tab li').removeClass("active"); //タブ内のliについているactiveクラスを取り除き
                $(parentElm).addClass("active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
                //表示させるエリア設定
                $(".area").removeClass("is-active"); //もともとついているis-activeクラスを取り除き
                $(hashIDName).addClass("is-active"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加
                $('.block2_1').removeClass('sp-dnone');
                $('.block2_2').removeClass('posi_fixed');
                $('.child_block').removeClass('show');
                $('.tab').removeClass('block2_tab_djustment');//20220616_池田 追記
                $('.block2_1').removeClass('posi_unset');//20220616_池田 追記
            }
        });
    }
}

function getChildIsOpening () {
    return $('.child_block.show').data('filter');
}

//タブをクリックしたら
$('.tab a').on('click', function () {
    var idName = $(this).attr('href'); //タブ内のリンク名を取得
    var childName = getChildIsOpening();
    if (childName) {
        $('.tab li').find('a').each(function () {
            var tabIDName = $(this).attr('href');
            if (tabIDName === idName && $(tabIDName).find(`[data-filter='${childName}']`).length) {
                var parentElm = $(this).parent();
                if (childName === 'searchByStore') {
                    $('.tabName__30 a').addClass("noSelect");
                }
                $('.tab li').removeClass("active");
                $(parentElm).addClass("active");
                $(".area").removeClass("is-active");
                $(idName).addClass("is-active").find(`[data-filter='${childName}']`).addClass('show');
            }
        });
    } else { 
        GethashID(idName);//設定したタブの読み込みと
    }
    if ($('.area.is-active .js-block-modifie').children().last().hasClass('js-last-item')) {
        $('.area.is-active .js-block-modifie').children().last().addClass('border-d-none');
    }
    return false;//aタグを無効にする
});

$('.searchByStore').on('click', function () {
    $('.tabName__30 a').addClass("noSelect");
});

// 上記の動きをページが読み込まれたらすぐに動かす
$(window).ready(function () {
    var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
    GethashID(hashName);//設定したタブの読み込み
    if ($('.area.is-active .js-block-modifie').children().last().hasClass('js-last-item')) {
        $('.area.is-active .js-block-modifie').children().last().addClass('border-d-none');
    }
});

function queryStringToJSON(qs) {
    var pairs = qs.split('&');
    var result = {};
    pairs.forEach(function (p) {
        var pair = p.split('=');
        var key = pair[0];
        var value = decodeURIComponent(pair[1] || '');
        if (result[key]) {
            if (Object.prototype.toString.call(result[key]) === '[object Array]') {
                result[key].push(value);
            } else {
                result[key] = [result[key], value];
            }
        } else {
            result[key] = value;
        }
    });
    return result;
}

$('.formFilterByColor').submit(function (event) {
    event.preventDefault();
    var formData = $(this).serialize();
    var cgid = $(this).find('input[name="hamburger_cgid"]').val();
    var sort = getCookie('sort') ? getCookie('sort') : 'score';
    var stock_none = getCookie('stock_none') ? getCookie('stock_none') : 0;
    var size = getCookie('size') ? getCookie('size') : 90;

    var querystring = queryStringToJSON(formData);
    querystring.gender = cgid;
    querystring.sort = sort;
    querystring.stock_none = stock_none;
    querystring.grouping = 0;
    querystring.size = size;
    if (Array.isArray(querystring.color)) {
        querystring.color = querystring.color.join('|');
    }
    querystring = '?' + Object.keys(querystring).map(key => `${key}=${querystring[key]}`).join('&');
    var url = $(this).attr('action') + querystring;
    location.href = url;
});

// 上記の動きをページが読み込まれたらすぐに動かす
$(window).on('load', function () {
    var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
    GethashID(hashName);//設定したタブの読み込み
});

$('.virtualStore').on('click', function () {
    var url = $(this).data('url');
    if (window.location.href.split('#')[0] !== url.split('#')[0]) {
        window.location.href = url;
    } else {
        window.location.replace(url);
        window.location.reload();
    }
});

$('.parent_block .parent_li a.none-redirect').on('click', function (e) {
    e.preventDefault();
});

$(window).on('load', function(){
    var swiperEls = {};
    function setupSwiper() {
      const windowWidth = $(window).width();
      const optionDefault = {
        spaceBetween: 5,
        slidesPerView: 3.9,
        preloadImages: false,
        loop: false,
        centeredSlides: false,
        loopedSlides: 2,
        a11y: false,
        enabled: false,
        breakpoints: {
          768: {
            enabled: true
          }
        }
      }
  
      const elm = $('.swiper-container.js-item-swiper');
      elm.each((index, element) => {
        const elementId = $(element).data('id');
  
        // Destroy swiper if applicable
        if (swiperEls[elementId]) {
          swiperEls[elementId].destroy();
        }
  
        optionDefault.navigation = {
          nextEl: '.next-button-' + elementId,
          prevEl: '.prev-button-' + elementId
        };
  
        // change setting swiper
        if (windowWidth <= 764) {
          optionDefault.slidesPerView = $(element).data('sp-slideperview') || 2.5;
          optionDefault.spaceBetween = 0;
        }
  
        // init swiper when page load or resize window
        swiperEls[elementId] = new Swiper('.' + elementId, optionDefault);
        const prevarrow = $('.prev-button-' + elementId)[0];
        const nextarrow = $('.next-button-' + elementId)[0];
        prevarrow.style.display = 'none';
        nextarrow.style.display = 'none';
  
        if (windowWidth > 764) {
  
          if (swiperEls[elementId].slides.length > 4) {
            nextarrow.style.display = 'block';
          }
  
          swiperEls[elementId].on('slideChange', function () {
            const realIndex = swiperEls[elementId].realIndex;
            const activeIndex = swiperEls[elementId].slides.length - 4;
            realIndex == 0 ? prevarrow.style.display = 'none' : prevarrow.style.display = 'block';
            realIndex == activeIndex ? nextarrow.style.display = 'none' : nextarrow.style.display = 'block';
          });
        }
      });
    }
  
    // display block recently-viewed if image is display
    var intervalSwiper = setInterval(() => {
      var elmRecently = document.querySelectorAll(".recently-viewed");
      $(elmRecently).each(function (index, elm) { 
            if (!$(elm).hasClass('display')) {
                $(elm).addClass('display');
                $(elm).css('opacity', 1);
                setupSwiper();
                AOS.init();
            }
      });
    });

    // will stop interval after 20s if don't have block recently-viewed
    setTimeout(() => { clearInterval(intervalSwiper); }, 10000);

    window.addEventListener('resize', function () {
      setupSwiper();
    });
  });

function getPositionAccordion() {
    var name = $('.page').attr("data-action") + $('.page').attr("data-querystring");
    var getListPosition = JSON.parse(sessionStorage.getItem(name));
    if ($('.accordion__click').length > 0 && sessionStorage.getItem('total' + name) == $('.accordion__click').length) {
        getListPosition.forEach((index) => {
            // work for store locator page
            $(".accordion__head").eq(index).removeClass('is-open');
            $(".accordion__body").eq(index).css('display','none');
            // work for customer category page
            $(".category__icon").eq(index).addClass('is-open');
            $(".category__items").eq(index).css('display','block');
        });
    } 
    // work for content asset faq-toggle-fs
    if ($('.faq-title_toggle').length > 0 && sessionStorage.getItem('total' + name) == $('.faq-title_toggle').length) {
        getListPosition.forEach((index) => {
            $(".faq-title_toggle").eq(index).addClass('active');
            $(".faq-content-collapse").eq(index).css('display','block');
        });
    }
}

function setPositionAccordion() {
    $('.accordion__click, .faq-title_toggle').click(function() {
        var position = $(this).index('.accordion__click');
        var className = '.accordion__click';
        // work for content asset faq-toggle-fs
        if ($('.faq-title_toggle').length > 0) {
            position = $(this).closest('.faq-sub-heading-content').index('.faq-sub-heading-content');
            className = '.faq-title_toggle';
        }
        if ($('.accordion__click').length > 0) {
            $(this).next().slideToggle();
            $(this).toggleClass('is-open');
            $(this).children('.category__icon').toggleClass( 'is-open' );
        } 
        if (position !== null && position !== undefined) {
            var name = $('.page').attr("data-action") + $('.page').attr("data-querystring");
            var arr = sessionStorage.getItem(name) ? JSON.parse(sessionStorage.getItem(name)) : [];
            if (!arr.includes(position)) {
                arr.push(position);
            } else {
                arr.splice(arr.indexOf(position), 1);
            }
            sessionStorage.setItem('total' + name, JSON.stringify($(`${className}`).length));
            sessionStorage.setItem(name, JSON.stringify(arr));
        }
    });
}

function removeBorderOnHamburgerMenu () { 
    const parentBlocks = $('.block2_2').find('.is-active .parent_block');
    const lastBlockIndex = parentBlocks.length - 1;

    parentBlocks.each(function (index) {
        const $block = $(this);
        const $parentLis = $block.find('.parent_li');
        if (index !== lastBlockIndex) {
            $parentLis.last().css('border-bottom', 'none');
        }
    });
}

// fix jerk when scroll to old position
function backBrowserScroll() {
    var pageAction = $('.scroll_page').data('pagetype');

    if (pageAction) {
        var strScroll = 'c' + pageAction;
        var strHeight = 'heightHompage_' + pageAction;

        var changePos = sessionStorage.getItem(strScroll);
        var changeHeight = sessionStorage.getItem(strHeight);

        $('body').on('click', 'a', function (e) {
            var scrollPosition =  window.scrollY;
            sessionStorage.setItem(strHeight, document.documentElement.scrollHeight);
            sessionStorage.setItem(strScroll, scrollPosition);
        });

        $(document).ready(function () {
            if (String(window.performance.getEntriesByType("navigation")[0].type) === "back_forward" && changePos) {
                $('body').css('height', changeHeight);
                window.scroll(0, changePos);
            }
        });

        window.onload = function() {
            sessionStorage.removeItem(strScroll);
            sessionStorage.removeItem(strHeight);
            setTimeout(function () {
                if (String(window.performance.getEntriesByType("navigation")[0].type) === "back_forward" && changePos) {
                    window.scroll(0, changePos);
                }

                $('body').css('height', 'auto');
            }, 800);
        };
    }
}

function handleScroll () {
    var menuSection = $('#g-nav, .back');
    var width = $(window).width();
    var appRecommend = $('.app-recommend:visible').outerHeight() || 0;
    var headerbanner = $('.header-banner-mkt:visible').outerHeight() || 0;
    //Now aside from SFCC banner,also consider Braze banner height
    headerbanner += $('.header-banner-braze:visible').outerHeight() || 0;
    var headerElement = document.querySelector('header.header_nav');
    var headerDisplay = window.getComputedStyle(headerElement).display;
    var headerBlock = $('.header_block').outerHeight();
    var minusHeight = 0;
    if (width < 768) {
        menuSection.css('top', '0' + 'px');
    }
    //When app recommend is display, adjust the position of header nav to below app recommend
    if ($('.app-recommend').css('display') === 'block') {
        $('.header_nav').css('top', `${-appRecommend || 0}px`).css('margin-top', `${appRecommend}px`);
    }

    //If header banner (braze, sfcc) are both not display and app recommend is not display, fix the header block to top
    if (!$('.header_nav').find('.header-banner-braze').length > 0 && !$('.header_nav').find('.header-banner-mkt').length > 0 && $('.app-recommend').css('display') !== 'block') {
        $('.header_block').css('position', 'fixed');
        if (headerDisplay != 'none') {
            $('.home_page').css('padding-top', headerBlock + 'px');
        }
    }
    //When one of them header banner (braze, sfcc) is display, app recommend is not display,
    //  and scrollY is over the total header banner height, fix the header block to top
    if (($('.header-banner-mkt').css('display') === 'block' || $('.header-banner-braze').css('display') === 'block') 
        && $('.app-recommend').css('display') !== 'block' && window.scrollY >= headerbanner) {
        $('.header_nav').css('top', `${-headerbanner || 0}px`);
        if (headerDisplay != 'none') {
            $('.home_page').css('padding-top', headerBlock + 'px');
        }
        $('.header_block').css('position', 'fixed');
        $('#g-nav').css('padding-top', '0px');
    }
    //If scrollY is less than header banner height, reset the header block position to not fixed and scroll to top
    if (window.scrollY < headerbanner && $('.app-recommend').css('display') !== 'block') {
        $('.header_nav').css('top', '0px');
        $('.home_page').css('padding-top', '0px');
        $('.header_block').css('position', 'relative');
        minusHeight += headerbanner;
    }
    
    if (width >= 768) {
        minusHeight = $('#g-nav .block1').outerHeight() + $('#g-nav .block2_2 .tab').outerHeight(); 
        $('#g-nav .block2_2 .area').css('height', "calc(100vh - "+minusHeight+"px)");
    } else {
        $('#g-nav .block2_2 .area').css('height', "auto");
    }
}

$('.block2_2 .tab a').on('click', function () {
    removeBorderOnHamburgerMenu();
});

$(function () {
  setPositionAccordion();
  getPositionAccordion();
  backBrowserScroll();
  handleScroll();
  removeBorderOnHamburgerMenu();
});

$(function () {
    $('.header__hamburger').on('click', function () {
        $(`.tabName__${getCookie("cgid") == "20" ? "20" : "10"} a`).trigger('click');
    });
});

//Reload header block styling when braze banner is added
$(window).on('load', function(){
    var intervalAddSlideBraze = setInterval(function () {
        var isShowBrazeBanner = $('.header-banner-braze') || null;
        if (isShowBrazeBanner) {
            handleScroll();
            clearInterval(intervalAddSlideBraze);
            //Calculate min-height for maincontent again when braze banner is added
            if (!$('.header-banner-mkt').css('display') === 'block' && $('section.footer_block').length > 0) {
                $('#maincontent').css('min-height', $(window).height() - $('#maincontent').offset().top - $('section.footer_block').outerHeight(true) + 'px');
            }
        }
    }, 500);
    setTimeout(function() {
        clearInterval(intervalAddSlideBraze);
    }, 7000);
});